import React from "react";
import Container from "./styled";
import { FaFacebookF } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";
import { Link } from "react-router-dom";

export default function Footer({ link, marcas, pagina }) {
  return (
    <Container pagina={pagina}>
      {/* Data Nav Container */}
      <div className="data-nav-container">
        {/* Data Container */}
        <div className="data-container">
          {/* Logo */}
          <Link to={link ? link : "/"}>
            <img alt="Seguro Motos Logo" src="/logos/seguromotos.svg"></img>
          </Link>
          {/* Social Media Mobile Container */}
          <div className="social-media-mobile-container">
            {/* Botón Facebook */}
            <a
              href="https://www.facebook.com/SeguroMotosOficial/"
              target="_blank"
            >
              <FaFacebookF />
            </a>
            {/* Botón Instagram */}
            <a href="https://www.instagram.com/seguromotos/" target="_blank">
              <BsInstagram />
            </a>
            {/* Botón WhatsApp */}
            <a
              href="https://api.whatsapp.com/send?phone=541164358739&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20SeguroMotos!%20"
              target="_blank"
            >
              <BsWhatsapp />
            </a>
          </div>
          {/* Data */}
          <div className="data">
            <a href="tel:08102202373">0810-220-2373</a>
            {/* <a href="tel:1164358739">
              <BsWhatsapp style={{ marginRight: "8px", color: "#25D366" }} />
              (011) 64358739
            </a> */}
            <p>info@seguroweb.com.ar</p>
            <p>Suipacha 245 1° Piso CABA</p>
          </div>
        </div>
        {/* Navs Container */}
      </div>
      {/* Social Media y Logos Container */}
      <div className="social-media-logos-container">
        {/* Social Media Container */}
        <div className="social-media-container">
          {/* Facebook Button */}
          <a
            href="https://www.facebook.com/SeguroMotosOficial/"
            target="_blank"
          >
            <FaFacebookF />
          </a>
          {/* Instagram Button */}
          <a href="https://www.instagram.com/seguromotos/" target="_blank">
            <BsInstagram />
          </a>
          {/* WhatsApp Button */}
          {/* <a
            href="https://api.whatsapp.com/send?phone=541164358739&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20SeguroMotos!%20"
            target="_blank"
          >
            <BsWhatsapp />
          </a> */}
        </div>
        {/* Logos Container */}
        <div className="logos-container">
          {/* Logo */}
          <a
            href="https://www.seguroweb.com.ar/"
            target="_blank"
            id="logo-sw-boton"
          >
            <img
              alt="Logo SeguroWeb"
              src="/logos/seguroweb.svg"
              id="logo-sw"
            ></img>
          </a>
          {/* Logo */}
          <img
            alt="Logo Lets Encrypt"
            src="/logos/letsencrypt.png"
            id="logo-encrypt"
          ></img>
          {/* Logo */}
          <a
            href="https://www.gyssrl.com.ar/webroot/footer/certificadoapt.pdf"
            target="_blank"
            id="logo-SSN"
          >
            <img alt="Logo SSN" src="/logos/ssn.png" id="logoSSN"></img>
          </a>
          {/* Logo */}
          <img alt="Logo PDP" src="/logos/pdp.png" id="logo-PDP"></img>
          {/* Logo */}
          <a
            href="https://servicios1.afip.gov.ar/clavefiscal/qr/response.aspx?qr=vfDql9TuSM09b_FRxAacFg,,"
            target="_F960AFIPInfo"
            id="logo-fiscal"
          >
            <img alt="Logo Data Fiscal" src="/logos/datafiscal.webp"></img>
          </a>
        </div>
        <img
          alt="Edificios del isotipo de Gestión y Servicios"
          src="/footer/edificios-borde.svg"
          id="edificios"
        ></img>
      </div>
      {/* Texto Copyright */}
      <div id="texto-copyright-container">
        <p>
          © Copyright {new Date().getFullYear()} SeguroMotos | Todos los derechos reservados |
          SeguroMotos es marca de Gestión y Servicios S.R.L.
        </p>
      </div>
    </Container>
  );
}
